import React, {useEffect} from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Box,
  Text,
  FormControl,
  FormLabel,
  Input,
  Flex,
  SimpleGrid,
  Select,
  useToast,
  HStack,
} from '@chakra-ui/react';
import { useState } from 'react';
import { getData, postData } from '../../utils/httpClient';
import { useNavigate } from 'react-router-dom';

export default function CreatetModal({
  isOpen,
  onClose,
  formData,
  setFormData,
  onConfirm,
}) {
  const [studyTypes, setStudyTypes] = useState([]);
  const navigate = useNavigate();

  const toast = useToast();

  const getStudyTypes = async () => {
    try {
      const response = await getData('/studyTypes');
      setStudyTypes(response?.payload?.studyTypes || []);
    } catch (error) {
      toast({
        title: 'Error al cargar los tipos de estudio.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    getStudyTypes();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };


  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        maxWidth={{ base: '100%', md: '80%' }}
        minHeight={'85vh'}
        maxHeight={'85vh'}
        overflowY="auto"
      >
        <ModalHeader mb={5}>Agregar Estudio</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Flex
            direction={{ base: 'column', md: 'row' }}
            justify="space-between"
            align="center"
          >
            <Box flex="1" mb={5}>
                <SimpleGrid columns={{ base: 1 }} spacing={5} mt={4}>
                  {/* Description */}
                  <FormControl id="name" isRequired>
                    <FormLabel>Descripción</FormLabel>
                    <Input
                      placeholder="Descripción"
                      name="description"
                      value={formData.description}
                      onChange={handleInputChange}
                    />
                  </FormControl>

                  {/* Study Type - ahora dinámico (Módulo 8). */}
                  <FormControl id="studyTypeId" isRequired>
                    <FormLabel>Tipo de estudio</FormLabel>
                    <HStack>
                      <Select
                        name="studyTypeId"
                        value={formData.studyTypeId}
                        onChange={handleInputChange}
                      >
                        <option value="">Seleccione</option>
                        {studyTypes.map((type) => (
                          <option key={type.id} value={type.id}>
                            {type.description}
                          </option>
                        ))}
                      </Select>
                      <Button
                        size="sm"
                        variant="outline"
                        onClick={() => navigate('/admin/study-types')}
                      >
                        Gestionar
                      </Button>
                    </HStack>
                  </FormControl>

                </SimpleGrid>
            </Box>
          </Flex>
        </ModalBody>
        <ModalFooter>
          <Box>
              <Button
                colorScheme="blue"
                onClick={onConfirm}
                width="120px" // Fija el tamaño del botón
              >
                Completar
              </Button>
          </Box>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
